import React, { useState } from "react";
import toast from "react-hot-toast";
import Swal from "sweetalert2";

const KeyFeatures = ({ initialData = [], onChange , mytext }) => {
  const [features, setFeatures] = useState(initialData);
  const [featureText, setFeatureText] = useState("");
  const [editingId, setEditingId] = useState(null);

  const updateParent = (updated) => {
    setFeatures(updated);
    if (onChange) onChange(updated); // send data to parent
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!featureText.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Empty Field",
        text: "Please enter a feature.",
      });
      return;
    }

    if (editingId) {
      const updated = features.map((item) =>
        item.id === editingId ? { ...item, text: featureText.trim() } : item
      );
      updateParent(updated);
      setEditingId(null);
    } else {
      const newFeature = {
        id: Date.now(),
        text: featureText.trim(),
      };
      updateParent([...features, newFeature]);
    }

    setFeatureText("");
 
    toast.success(editingId ? "Updated!" : "Added!")
  };

  const handleEdit = (f) => {
    setEditingId(f.id);
    setFeatureText(f.text);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete this feature?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      const updated = features.filter((f) => f.id !== id);
      updateParent(updated);

      Swal.fire({
        icon: "success",
        title: "Deleted!",
        timer: 1200,
        showConfirmButton: false,
      });
      
    }
  };

  const handleCancel = () => {
    setEditingId(null);
    setFeatureText("");
  };

  return (
    <div className="my-4">
      <h5 className='mb-2'> {mytext ?? 'Features'} Section - </h5>
      <hr/>

      {/* Form */}
      <div className="card mb-4">
        <div className="card-header">
          {editingId ? `Edit ${mytext ?? 'Features'}` : `Add New ${mytext ?? 'Features'}`}
        </div>
        <div className="card-body">
          <div className="row g-3">
            <div className="col-12">
              <input
                type="text"
                className="form-control"
                placeholder="Type feature..."
                value={featureText}
                onChange={(e) => setFeatureText(e.target.value)}
              />
            </div>

            <div className="col-12 d-flex gap-2">
              <button type="button" onClick={handleSubmit} className="btn btn-primary">
                {editingId ? "Update" : `Add ${mytext ?? 'Features'}`}
              </button>
              {editingId && (
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Feature List */}
      <div className="card">
        <div className="card-header">{mytext ?? 'Features'} List</div>
        <div className="card-body">
          {features.length === 0 ? (
            <p className="text-muted mb-0">No {mytext ?? 'Features'} yet.</p>
          ) : (
            <ul className="list-group">
              {features.map((f) => (
                <li
                  key={f.id}
                  className="list-group-item d-flex justify-content-between align-items-center"
                >
                  {f.text}

                  <div className="btn-group">
                    <button
                      className="btn btn-sm btn-outline-primary"
                      type="button"
                      onClick={() => handleEdit(f)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      type="button"
                      onClick={() => handleDelete(f.id)}
                    >
                      Delete
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default KeyFeatures;
